import React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { ISearchTerm } from '../../core/application/contexts/ConfigurationContext'
import { DropOffLocation } from '../../core/domain/models'
import LeftArrowIcon from '../icons/LeftArrowIcon'
import MostPopularSearches from '../sideMenu/MostPopularSearches'
import DropOffLocationItem from './DropOffLocationItem'
import MobileSearchInput from './MobileSearchInput'
import PanelContainer from './PanelContainer'
import { Location } from '../../core/domain/models/Location'
import { useMapContext } from '../../core/application/contexts'

export interface ISearchPanel {
  dropOffLocationList: DropOffLocation[]
  mostPopularSearchTerms?: Array<ISearchTerm>
  onReturn: () => void
  onSelect: (location: DropOffLocation) => void
  togglePanel: (isOpen: boolean) => void
}

const SearchPanel: React.FC<ISearchPanel> = ({
                                               togglePanel,
                                               dropOffLocationList,
                                               mostPopularSearchTerms = [],
                                               onSelect,
                                               onReturn
                                             }) => {
  const { panTo } = useMapContext()

  const handleTagOnClick = (value: string) => {
    console.log('filter with > ', value)
  }

  const handleSelect = (location: Location): void => {
    panTo(location)
    togglePanel(false)
  }

  return (
    <Container data-testid='searchPanel-container'>
      <GoBackWrapper data-testid='goBack-button' onClick={onReturn}>
        <LeftArrowIcon />
        <FormattedMessage id='DropOffDetails.GoBack.Label' />
      </GoBackWrapper>
      <SearchInputWrapper>
        <MobileSearchInput onSelectCallback={handleSelect} />
      </SearchInputWrapper>
      {mostPopularSearchTerms.length > 0 && (
        <PopularSearchesWrapper>
          <MostPopularSearches onClick={handleTagOnClick} terms={mostPopularSearchTerms} />
        </PopularSearchesWrapper>
      )}
      <DropOffLocationList>
        {dropOffLocationList.slice(0, 20).map((dropOffLocation) => {
          return (
            <DropOffLocationItem
              types={dropOffLocation.types}
              id={dropOffLocation.storeId}
              key={dropOffLocation.storeId}
              name={dropOffLocation.name}
              address={dropOffLocation.address}
              picture={dropOffLocation.firstPicture}
              coordinate={dropOffLocation.coordinate}
              onClick={() => {
                onSelect(dropOffLocation)
              }}
            />
          )
        })}
      </DropOffLocationList>
    </Container>
  )
}

const Container = styled(PanelContainer)`
  padding: 24px 0;
`

const GoBackWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-size: ${({ theme }) => theme.size.normal};
  color: ${({ theme }) => theme.color.black};
  column-gap: 8px;
  cursor: pointer;
  margin-bottom: 12px;
  padding: 0 24px;
`

const SearchInputWrapper = styled.div`
  height: 48px;
  width: 100%;
  margin-bottom: 16px;
  padding: 0 24px;
`

const PopularSearchesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 24px;
`

const DropOffLocationList = styled.div`
  overflow-x: auto;
  overflow-y: hidden;

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  column-gap: 8px;

  & > div {
    flex: 0 0 auto;
  }

  & > div:first-child {
    margin-left: 24px;
  }

  & > div:last-child {
    margin-right: 24px;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`

export default SearchPanel
